<template>
  <f7-page login-screen class="pageCoachJose">
    <navbarchat></navbarchat>

    <f7-messagebar
      ref="messagebar"
      :placeholder="'global.coach_jose_write' | translate"
    >
      <f7-link
        slot="inner-end"
        @click="sendMessage"
      >
      <img class="icon" height="20px" src="/static/icons/send.svg" alt />
    </f7-link>
    </f7-messagebar>
    <f7-messages ref="messages">
      <f7-messages-title>
        <img style="height: 150px;" src="/static/coach_jose.png" alt />
      </f7-messages-title>
      <f7-message
        v-for="(message, index) in messagesData"
        :key="index"
        :type="message.type"
        :image="message.image"
        :name="message.name"
        :avatar="message.type === 'received' ? `${hostApp}/static/coach_jose_avatar.png` : ''"
        :first="isFirstMessage(message, index)"
        :last="isLastMessage(message, index)"
        :tail="isTailMessage(message, index)"
        :class="{ 'message-tile': message.results || message.paywall }"
      >
        <span slot="text" v-if="message.text" v-html="message.text"></span>
        <p v-if="message.intro" slot="text" class="jose-intro">{{ message.intro }}</p>
        <div v-if="message.results" slot="text" class="jose-tiles" :class="{ 'jose-tiles--multi': message.results.length > 1 }">
          <a
            v-for="result in message.results"
            :key="`${result.book_id}-${result.data.typeElem}-${result.data.id}`"
            class="jose-tile"
            :class="{ 'jose-tile--locked': message.locked, external: !message.locked }"
            :href="message.locked ? null : tileLink(result)"
            :target="message.locked ? null : '_blank'"
          >
            <div class="jose-tile__media">
              <!-- Atrapa grafiki (tylko front) dla użytkownika bez subskrypcji - grafika już rozmyta w pliku -->
              <img v-if="result.fake" class="jose-tile__fake-img" :src="result.fakeImage" alt />
              <img v-else-if="result.image" :src="`${hostApp}${result.image}`" alt loading="lazy" />
              <img v-else class="jose-tile__placeholder" src="/static/coach_jose.png" alt />
              <span class="jose-tile__badge" :class="result.data.typeElem == 'session' ? 'typeElemSession' : 'typeElemExercise'">
                {{ (result.data.typeElem === 'session' ? 'books.outline' : 'books.exercise') | translate }}
              </span>
              <span v-if="message.locked" class="jose-tile__lock" :class="{ 'jose-tile__lock--fake': result.fake }"><svg class="jose-lock-icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 1.5a5.5 5.5 0 0 0-5.5 5.5v3H5a1 1 0 0 0-1 1v10.5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-1.5V7A5.5 5.5 0 0 0 12 1.5zm-3.5 5.5a3.5 3.5 0 0 1 7 0v3h-7V7z"/></svg></span>
            </div>
            <div class="jose-tile__body">
              <template v-if="result.fake">
                <span class="jose-skeleton jose-skeleton--title"></span>
                <span class="jose-skeleton jose-skeleton--title jose-skeleton--short"></span>
                <span class="jose-skeleton"></span>
                <span class="jose-skeleton jose-skeleton--short"></span>
              </template>
              <template v-else>
                <p class="jose-tile__title">{{ plainText(result.data.title) }}</p>
                <p v-if="result.data.subject" class="jose-tile__subject">{{ plainText(result.data.subject) }}</p>
                <p v-if="result.book_title" class="jose-tile__book">📘 {{ result.book_title }}</p>
              </template>
              <span v-if="message.locked" class="jose-tile__locked-label"><svg class="jose-lock-icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 1.5a5.5 5.5 0 0 0-5.5 5.5v3H5a1 1 0 0 0-1 1v10.5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-1.5V7A5.5 5.5 0 0 0 12 1.5zm-3.5 5.5a3.5 3.5 0 0 1 7 0v3h-7V7z"/></svg> {{ 'global.coach_jose_locked_label' | translate }}</span>
              <span v-else class="button button-raised jose-tile__cta">
                {{ (result.data.typeElem === 'session' ? 'global.coach_jose_response_subscription_outline' : 'global.coach_jose_response_subscription_exercise') | translate }} →
              </span>
            </div>
          </a>
        </div>
        <div v-if="message.paywall" slot="text" class="jose-paywall">
          <p class="jose-paywall__title"><svg class="jose-lock-icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 1.5A5.5 5.5 0 0 0 6.5 7v.5h2V7a3.5 3.5 0 0 1 7 0v3H5a1 1 0 0 0-1 1v10.5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-1.5V7A5.5 5.5 0 0 0 12 1.5z"/></svg> {{ 'global.coach_jose_paywall_title' | translate }}</p>
          <ul class="jose-paywall__benefits">
            <li>✅ {{ 'global.coach_jose_paywall_benefit_1' | translate }}</li>
            <li>✅ {{ 'global.coach_jose_paywall_benefit_2' | translate }}</li>
            <li>✅ {{ 'global.coach_jose_paywall_benefit_3' | translate }}</li>
          </ul>
          <div class="jose-paywall__plans">
            <a
              v-for="plan in subscriptionPlans"
              :key="plan.months"
              class="jose-plan"
              :class="{ 'jose-plan--best': plan.months === 12 }"
              @click="goToStripe(plan.link)"
            >
              <span v-if="plan.months === 12" class="jose-plan__badge">{{ 'global.coach_jose_paywall_best_value' | translate }}</span>
              <span class="jose-plan__months">{{ `payment.plan_${plan.months}` | translate }}</span>
              <span class="jose-plan__price">{{ plan.price }} {{ subscriptionCurrency }}</span>
              <span v-if="plan.months > 1" class="jose-plan__per-month">
                {{ pricePerMonth(plan) }} {{ subscriptionCurrency }} / {{ 'global.coach_jose_paywall_month' | translate }}
              </span>
            </a>
          </div>
          <p class="jose-paywall__warning">{{ 'payment.payment_warning' | translate }}</p>
        </div>
      </f7-message>
      <f7-message v-if="typingMessage"
        type="received"
        :typing="true"
        :first="true"
        :last="true"
        :tail="true"
        :header="`${typingMessage.name} is typing`"
        :avatar="`${hostApp}/static/coach_jose_avatar.png`"
      ></f7-message>
    </f7-messages>

  </f7-page>
</template>
<script>
import Navbarchat from "@/components/Navbar/Navbarchat.vue";
import joseServices from "@/services/JoseServices.js"
import CONSTANTS from "@/utils/constants.js"

// Rozmyte grafiki atrap (rozmycie jest w plikach, nie w CSS) - losowane dla zablokowanych kafelków
const JOSE_BLUR_IMAGES = [
  '/static/jose_blur.png',
  '/static/jose_blur_2.png',
  '/static/jose_blur_3.png',
  '/static/jose_blur_4.png',
  '/static/jose_blur_5.png',
  '/static/jose_blur_6.png',
];

// Liczba wariantów tekstów global.coach_jose_intro_<grupa>_<n> w locale/pl.js i en.js
const JOSE_INTRO_COUNT = { outline: 5, exercise: 5, both: 5, locked: 3 };

export default {
  components: {
    Navbarchat,
  },
    data() {
      return {
        typingMessage: null,
        seenKeys: [],
        // Bez subskrypcji (gość lub konto) demo działa 1 raz na sesję czatu - odświeżenie strony resetuje
        demoUsed: false,
        lastIntro: null,
        messagesData: [
          {
            name: 'José',
            type: 'received',
            text: this.$t('global.coach_jose_init_full_1'),
            
          },
          {
            name: 'José',
            type: 'received',
            text: this.$t('global.coach_jose_init_full_2'),
          },
        ],
        responseInProgress: false,
        responseBackend: {
          search_text: '',
          results: null,
          status: ''
        },
        responseStatus: null
      };
    },
    computed: {
      // Jak na stronie cennika: PL -> PLN (STRIPE_REDIRECTS[0]), pozostałe -> USD (STRIPE_REDIRECTS[1])
      subscriptionCurrencyIndex() {
        return this.getLang == 'pl' ? 0 : 1;
      },
      subscriptionCurrency() {
        return CONSTANTS.CURRENCY[this.subscriptionCurrencyIndex];
      },
      subscriptionPlans() {
        return CONSTANTS.STRIPE_REDIRECTS[this.subscriptionCurrencyIndex];
      },
    },
    mounted() {
      const self = this;
      self.$f7ready(() => {
        self.messagebar = self.$refs.messagebar.f7Messagebar;
        self.messages = self.$refs.messages.f7Messages;
        // Desktop only: Enter sends, Shift+Enter inserts a new line.
        // On mobile Enter keeps inserting a new line and sending is done via the button.
        if (self.$f7.device.desktop) {
          self.textareaEl = self.$refs.messagebar.$el.querySelector('textarea');
          if (self.textareaEl) {
            self.textareaEl.addEventListener('keydown', self.onTextareaKeydown);
          }
        }
      });
    },
    beforeDestroy() {
      if (this.textareaEl) {
        this.textareaEl.removeEventListener('keydown', this.onTextareaKeydown);
      }
    },
    methods: {
      // Tekst José jako osobny dymek, a pod nim drugi dymek z treścią (kafelki / plany)
      pushJoseMessages(intro, payload) {
        const base = { type: 'received', name: 'José' };
        this.messagesData.push({ ...base, intro });
        this.messagesData.push({ ...base, ...payload });
      },
      // Losowy tekst José przed znalezionymi materiałami (bez powtórki tego samego z rzędu)
      randomIntro(results, locked) {
        const types = results.map((result) => result.data.typeElem);
        let group = 'both';
        if (locked) group = 'locked';
        else if (types.length === 1) group = types[0] === 'session' ? 'outline' : 'exercise';
        const count = JOSE_INTRO_COUNT[group];
        let index = Math.floor(Math.random() * count) + 1;
        if (count > 1 && `${group}_${index}` === this.lastIntro) {
          index = (index % count) + 1;
        }
        this.lastIntro = `${group}_${index}`;
        return this.$t(`global.coach_jose_intro_${group}_${index}`);
      },
      // Atrapy z typów rozpoznanych przez backend (bez żadnych materiałów)
      fakeResults(types) {
        const list = Array.isArray(types) && types.length ? types : ['session', 'exercise'];
        // Losowe, różne od siebie grafiki dla każdego kafelka
        const images = [...JOSE_BLUR_IMAGES].sort(() => Math.random() - 0.5);
        return list.map((typeElem, index) => ({
          fake: typeElem,
          fakeImage: images[index % images.length],
          book_id: 'fake',
          data: { typeElem, id: typeElem },
        }));
      },
      goToStripe(link) {
        window.open(link, '_blank');
      },
      pricePerMonth(plan) {
        return (Math.floor((plan.price / plan.months) * 100) / 100).toFixed(2);
      },
      tileLink(result) {
        const { book_id, data } = result;
        return `/#!/books/${book_id}/${data.typeElem}s/${data.id}/`;
      },
      plainText(html) {
        return String(html || '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
      },
      onTextareaKeydown(event) {
        if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
        event.preventDefault();
        this.sendMessage();
      },
      async onChatMessage(message, demoUsed) {
          const ask = {
            message: message[0].text,
            lang: this.getLang,
            // Wyniki pokazane już w tej rozmowie - backend ich nie powtórzy
            seen: this.seenKeys,
            // Demo już wykorzystane w tej sesji -> backend bez subskrypcji nic nie zwraca
            demo_used: demoUsed
          }
          try {
            const responseChat = await joseServices.chat(ask);
            this.responseBackend = responseChat.data
            const shown = responseChat.data.seen_keys || [];
            this.seenKeys = this.seenKeys.filter((key) => !shown.includes(key)).concat(shown);
            return true;
          } catch (error) {
              this.$f7.toast
                .create({
                  text:
                    "Something went wrong with the chat. Please try again or contact your administrator.",
                              position: "bottom",
                
                  closeTimeout: 3000
                })
                .open();
            console.log(error);
            return false;
          }
      },
      pushMustLogin() {
        this.messagesData.push({
          text: `${this.$t('global.coach_jose_must_login_or_register')} 👇👇👇 <br><br> <a href="/login/"><b>${this.$t('auth.login_link')}</b></a> <br><br> ${this.$t('global.or')} <br><br> <a href="/register/"><b>${this.$t('auth.create_account')}</b></a>`,
          type: 'received',
          name: 'José',
        });
      },

      isFirstMessage(message, index) {
        const self = this;
        const previousMessage = self.messagesData[index - 1];
        if (message.isTitle) return false;
        if (!previousMessage || previousMessage.type !== message.type || previousMessage.name !== message.name) return true;
        return false;
      },
      isLastMessage(message, index) {
        const self = this;
        const nextMessage = self.messagesData[index + 1];
        if (message.isTitle) return false;
        if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
        return false;
      },
      isTailMessage(message, index) {
        const self = this;
        const nextMessage = self.messagesData[index + 1];
        if (message.isTitle) return false;
        if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
        return false;
      },
      sendMessage() {
        const self = this;
        const text = self.messagebar.getValue().replace(/\n/g, '<br>').trim();
        const messagesToSend = [];
        if (text.trim().length) {
          messagesToSend.push({
            text,
          });
        }
        if (messagesToSend.length === 0) {
          return;
        }
        // Clear area
        self.messagebar.clear();
        // Focus area
        if (text.length) self.messagebar.focus();
        // Send message
        self.messagesData.push(...messagesToSend);
        // Mock response
        if (self.responseInProgress) return;
        self.responseInProgress = true;
        setTimeout(() => {
          self.typingMessage = {
            name: 'José',
          };
          const finish = () => {
            self.typingMessage = null;
            self.responseInProgress = false;
          };
          // Gość, który w tej sesji już wykorzystał demo - od razu informacja, że trzeba mieć konto
          if (!this.isAuthenticated && this.demoUsed) {
            setTimeout(() => {
              this.pushMustLogin();
              finish();
            }, 2000);
            return;
          }

          this.onChatMessage(messagesToSend, this.demoUsed).then((ok) => {
            setTimeout(() => {
              if (!ok) return finish();
              // Backend zwraca listę wyników: 1 konspekt i/lub 1 ćwiczenie
              const results = this.responseBackend.results || [];
              const status = this.responseBackend.status;

              if (status === 'exist_and_subscription') {
                // 1 dymek: tekst José, 2 dymek: kafelki ze znalezionymi materiałami
                this.pushJoseMessages(this.randomIntro(results, false), { results });
                finish();
              } else if (status === 'exist_demo') {
                // Backend (gość / brak subskrypcji) zwrócił materiały demo - 1 raz na sesję
                this.demoUsed = true;
                // Wygląda jak zwykła odpowiedź - bez dopisków o demo
                this.pushJoseMessages(this.randomIntro(results, false), { results });
                finish();
              } else if (status === 'login_required') {
                // Gość z wykorzystanym demo - informacja o koncie
                this.pushMustLogin();
                finish();
              } else if (status === 'subscription_required' || status === 'quota') {
                // Konto bez subskrypcji z wykorzystanym demo: backend nie zwraca materiałów, tylko
                // typy (konspekt / ćwiczenie) - pokazujemy zablokowane atrapy, a chwilę później plany.
                const fakeResults = this.fakeResults(this.responseBackend.types);
                this.pushJoseMessages(this.randomIntro(fakeResults, true), { results: fakeResults, locked: true });
                setTimeout(() => {
                  // Tak samo: tekst w 1 dymku, plany subskrypcji w 2 dymku
                  this.pushJoseMessages(this.$t('global.coach_jose_subscription_required'), { paywall: true });
                  finish();
                }, 1500);
              } else {
                self.messagesData.push({
                  text: `${this.$t('global.coach_jose_empty_response')}`,
                  type: 'received',
                  name: 'José',
                });
                finish();
              }
            }, 4000);
          });
        }, 1000);
      },
    },
  };
</script>

<style scoped lang="scss">
.pageCoachJose {
  background: white;
}

// Wiadomość z kafelkami - w dymku José (jego tło), szersza niż zwykła wiadomość
::v-deep .message-tile {
  max-width: calc(100% - 16px);

  .message-content {
    max-width: 100%;
  }

  .message-bubble {
    padding: 8px;
  }
}

.jose-intro {
  margin: 0;
}

.jose-tiles {
  display: flex;
  align-items: stretch;

  .jose-tile + .jose-tile {
    margin-left: 10px;
  }

  // 2 kafelki obok siebie - dzielą szerokość po równo
  // 2 kafelki obok siebie - każdy 260px jak pojedynczy, zwężają się tylko gdy brak miejsca
  &--multi .jose-tile {
    flex: 0 1 260px;
    min-width: 0;
    width: 260px;
    max-width: 260px;
  }
}

.jose-tile {
  display: flex;
  flex-direction: column;
  width: 260px;
  max-width: 70vw;
  overflow: hidden;
  border-radius: 14px;
  background: #fff;
  color: #1f2a24;
  text-decoration: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
  }

  &__media {
    position: relative;
    height: 160px;
    background: linear-gradient(135deg, #e9f5ec, #d3ecd9);
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .jose-tile__placeholder {
      width: auto;
      height: 70%;
      background: transparent;
      opacity: 0.85;
    }
  }

  // Tag jak w Bibliotece (assets/scss/pages/book.scss -> .demoBook)
  &__badge {
    position: absolute;
    top: 6px;
    right: 6px;
    padding: 3px 5px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: white;

    &.typeElemSession {
      background: #064516;
    }

    &.typeElemExercise {
      background: #11c43e;
    }
  }

  &__lock {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 34px;
    background: rgba(255, 255, 255, 0.35);
  }

  &__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px 12px 12px;
  }

  &__title {
    margin: 0 0 4px;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__subject,
  &__book,
  &__note {
    margin: 0 0 4px;
    font-size: 12px;
    line-height: 1.35;
    color: #5f6b64;
  }

  &__subject {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__note {
    color: #b26a00;
    margin-bottom: 8px;
  }

  // Guzik w stylu aplikacji (.button.button-raised z assets/scss/pages/all.scss)
  &__cta {
    margin-top: auto;
    width: 100%;
    text-align: center;
  }
}

// Atrapa: rozmycie jest w samym pliku jose_blur.png (bez filter: blur w CSS)
.jose-tile__fake-img {
  object-fit: cover;
}

// Płaska, pełna kłódka
.jose-lock-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
}

// Atrapa tekstu w zablokowanym kafelku
.jose-skeleton {
  display: block;
  height: 9px;
  margin-bottom: 7px;
  border-radius: 5px;
  background: #dfe4e1;
  filter: blur(1px);

  &--title {
    height: 13px;
    background: #c9d0cc;
  }

  &--short {
    width: 60%;
  }
}

.jose-tile__lock--fake {
  background: transparent !important;
  color: #fff;
}

.jose-tile__locked-label {
  margin-top: auto;
  font-size: 12px;
  font-weight: 700;
  color: #5f6b64;
}

.jose-tile--locked {
  cursor: default;

  &:hover {
    transform: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  }
}

// Blok "odblokuj José" z planami subskrypcji
.jose-paywall {
  // stała szerokość = szerokość siatki planów, teksty łamią się do niej
  width: 340px;
  max-width: 100%;
  box-sizing: border-box;
  padding: 12px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);

  &__title {
    margin: 0 0 6px;
    font-size: 15px;
    font-weight: 700;
  }

  &__benefits {
    margin: 0 0 10px;
    padding: 0;
    list-style: none;
    font-size: 13px;
    line-height: 1.6;
  }

  &__plans {
    display: flex;
    flex-wrap: wrap;
    margin: -4px;
  }

  &__warning {
    margin: 8px 0 0;
    font-size: 11px;
    line-height: 1.35;
    color: #5f6b64;
  }
}

.jose-plan {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // 2 plany w rzędzie na całą szerokość boxa
  flex: 1 1 calc(50% - 8px);
  width: calc(50% - 8px);
  margin: 4px;
  padding: 14px 6px 10px;
  border: 2px solid #e3e7e4;
  border-radius: 12px;
  text-align: center;
  color: #1f2a24;
  cursor: pointer;
  transition: border-color 0.15s ease, transform 0.15s ease;

  &:hover {
    border-color: #000;
    transform: translateY(-1px);
  }

  &__badge {
    position: absolute;
    top: -9px;
    padding: 2px 6px;
    border-radius: 5px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    color: #fff;
    background: #11c43e;
  }

  &__months {
    font-size: 12px;
    color: #5f6b64;
  }

  &__price {
    margin-top: 2px;
    font-size: 18px;
    font-weight: 700;
  }

  &__per-month {
    font-size: 11px;
    color: #5f6b64;
  }

  &--best {
    border-color: #000;
    background: #000;
    color: #fff;

    .jose-plan__months,
    .jose-plan__per-month {
      color: rgba(255, 255, 255, 0.75);
    }
  }
}

// Telefon: mniejsze kafelki, żeby 2 zmieściły się obok siebie
@media (max-width: 480px) {
  .jose-tiles .jose-tile + .jose-tile {
    margin-left: 8px;
  }

  .jose-tiles--multi .jose-tile {
    .jose-tile__media {
      height: 110px;
    }

    .jose-tile__body {
      padding: 8px 9px 10px;
    }

    .jose-tile__title {
      font-size: 13px;
    }

    .jose-tile__subject,
    .jose-tile__book,
    .jose-tile__note {
      font-size: 11px;
    }

    .jose-tile__cta {
      font-size: 11px;
      white-space: normal;
      height: auto;
      min-height: 28px;
      line-height: 1.2;
      padding: 6px 4px;
    }
  }
}
</style>